<script setup lang="ts">
import ProgressFrame from './layout/ProgressFrame.vue';
import ButtonPrimary from '@/shared/components/button/ButtonPrimary.vue';
import router from '@/router';
import NoInternetIcon from '../assets/icon/no-internet.svg';
import HorizontalContentRow from '../components/HorizontalContentRow.vue';

const retrySearch = () => {
  router.replace({ name: 'SearchingSolshare' });
};
</script>

<template>
  <ProgressFrame
    pageClass="subsection-page"
    backgroundColor="bg-white"
    titleTight
  >
    <template #pageIcon>
      <NoInternetIcon />
    </template>
    <template #title> No Internet Connection </template>
    <template #subTitle> We could not find the SolShare online. </template>

    <HorizontalContentRow
      firstRow
      lastRow
      backgroundColor="bg-light"
      class="content"
    >
      <p class="offline-message">
        The SolShare requires an internet connection for commissioning and
        ongoing product support.
      </p>
    </HorizontalContentRow>

    <div class="button-container">
      <ButtonPrimary
        block
        @click="retrySearch"
        data-tn="offline-retry-search-btn"
      >
        Let's try again
      </ButtonPrimary>
    </div>
  </ProgressFrame>
</template>

<style lang="less" scoped>
.content {
  margin-top: 1.28rem;
}

.offline-message {
  text-align: center;
  font-weight: @font-weight-medium;
}

.button-container {
  margin: 0 @content-side-margin;
}
</style>
